module.exports = __webpack_public_path__ + "static/media/landing-image.d0323041.png";